export const baseSettings = {
  duration: 2000,
  triggerOnce: true,
  fraction: 0.3,
}
